import { render, staticRenderFns } from "./iqField.vue?vue&type=template&id=485492fa&scoped=true&"
import script from "./iqField.vue?vue&type=script&lang=js&"
export * from "./iqField.vue?vue&type=script&lang=js&"
import style0 from "./iqField.vue?vue&type=style&index=0&id=485492fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485492fa",
  null
  
)

component.options.__file = "iqField.vue"
export default component.exports